import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, $isTextNode } from 'lexical';

export function MaxLengthPlugin({ maxLength }: { maxLength: number }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!maxLength) return;
    return editor.registerUpdateListener(
      ({ editorState, prevEditorState, dirtyElements, dirtyLeaves }) => {
        if (dirtyElements.size === 0 && dirtyLeaves.size === 0) {
          // No changes were made, so we can skip this update
          return;
        }

        editor.update(() => {
          const root = $getRoot();
          let text = '';
          let exceeded = false;

          root.getChildren().forEach((child) => {
            if ($isTextNode(child)) {
              text += child.getTextContent();
            }
          });

          if (text.length > maxLength) {
            exceeded = true;
            // Truncate the text to the maximum length
            let remainingChars = maxLength;
            root.getChildren().forEach((child) => {
              if ($isTextNode(child)) {
                const childText = child.getTextContent();
                if (remainingChars > 0) {
                  const truncatedText = childText.slice(0, remainingChars);
                  child.setTextContent(truncatedText);
                  remainingChars -= truncatedText.length;
                } else {
                  child.remove();
                }
              }
            });
          }

          if (exceeded) {
            // Restore the selection to the end of the truncated text
            const lastTextNode = root.getLastDescendant();
            if (lastTextNode) {
              lastTextNode.getTextContent().length;
            }
          }
        });
      }
    );
  }, [editor, maxLength]);

  return null;
}
